// gtm.js — MODULE 2: GTM Loader
//
// Loads GTM only when pbConfig.gtm_id is set.  Sites that have no
// ad/marketing tags (docs, product) omit gtm_id and skip this module.
//
// Execution sequence that GTM requires:
//   1. Define window.gtag stub (if not already present)
//   2. gtag('consent', 'default', { all: 'denied', wait_for_update: 500 })
//   3. Inject GTM script tag — GTM reads the consent defaults on load
//   4. Later: consentGranted() calls gtag('consent', 'update', ...)

import { cfg, LOG, dbg } from './config.js';

if (cfg.gtm_id && !cfg.no_track) {
  try {
    // 1. gtag stub — idempotent, GTM may also define it
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = function() { window.dataLayer.push(arguments); };
    }

    // 2. Consent Mode v2 defaults — all signals denied until user accepts.
    //    wait_for_update gives the consent banner ~500 ms to fire 'update'
    //    before GTM fires tags that read consent state.
    window.gtag('consent', 'default', {
      ad_storage:        'denied',
      analytics_storage: 'denied',
      ad_user_data:      'denied',
      ad_personalization:'denied',
      wait_for_update:   500
    });

    // 3. Load GTM asynchronously (standard GTM snippet, no noscript needed
    //    since this script itself requires JS)
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var gtmScript  = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src   = 'https://www.googletagmanager.com/gtm.js?id=' + cfg.gtm_id;
    document.head.appendChild(gtmScript);

    dbg('GTM loading', cfg.gtm_id);
  } catch (e) {
    console.error(LOG, 'GTM loader error', e);
  }
}
